import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Col, Row } from 'react-bootstrap';

export default function DarsupAlert(props) {
  let { children, variant = 'info', ...otherProps } = props;

  let alertInfoStyle = {
    color: getColor(variant),
    backgroundColor: getBGColor(variant),
    borderColor: getBorderColor(variant),
  };

  return (
    <Row>
      <Col md={{ span: 8, offset: 2 }}>
        <Alert variant={variant} style={alertInfoStyle} {...otherProps}>
          {children}
        </Alert>
      </Col>
    </Row>
  );
}

function getColor(variant) {
  switch (variant) {
    case 'info':
      return '#004085';
  }
}

function getBGColor(variant) {
  switch (variant) {
    case 'info':
      return '#cce5ff';
  }
}

function getBorderColor(variant) {
  switch (variant) {
    case 'info':
      return '#b8daff';
  }
}

DarsupAlert.propTypes = {
  variant: PropTypes.oneOf(['info']),
};
